module.exports = {
  apiKey: 'AIzaSyBixDsJgHiVPfQu6SY2QOiz42_eegMZI90',
  authDomain: 'roast-or-toast-app.firebaseapp.com',
  projectId: 'roast-or-toast-app',
  storageBucket: 'roast-or-toast-app.appspot.com',
  messagingSenderId: '1081647154316',
  appId: '1:1081647154316:web:7b69904dfc4fd0ed6a67a9',
  measurementId: 'G-V59DGSTW7P',
};
